
import { mapGetters, mapState } from 'vuex';
import { TRANSPARENT_IMAGE_URL } from '@/constants/IMAGE_URLS';
import EmbeddedSocialMediaReviewPc from './EmbeddedSocialMediaReviewPc';
import SocialMediaType from '@/enums/SocialMediaType';

export default {
  i18nComponentKey: 'ProductReviewsMediaCollage.components.ReviewMediaSectionPc',
  name: 'ReviewMediaSectionPc',
  components: { EmbeddedSocialMediaReviewPc },
  model: {
    prop: 'mediaPosition',
    event: 'change'
  },
  props: {
    review: { type: Object, default: null },
    mediaPosition: { type: Number, default: 1 }
  },
  computed: {
    ...mapGetters('review', ['isEmbeddedSocialMediaType']),
    ...mapState('reviewSettings', ['reviewSettings']),
    mediaShape() {
      return this.reviewSettings.show_thumbnail_as_square_on_popup
        ? 'square'
        : 'original-in-square';
    },
    isSocialMediaType() {
      return this.review.social_media_type !== SocialMediaType.NONE;
    },
    videoSrc() {
      const videoIdx = this.mediaPosition ? this.mediaPosition - 1 : 0;
      return this.review.videos[videoIdx]?.url;
    },
    imageSrc() {
      const imageIdx = this.mediaPosition
        ? this.mediaPosition - this.review.videos.length - 1
        : 0;
      return this.review.images[imageIdx]?.url || TRANSPARENT_IMAGE_URL;
    }
  }
};
